import React, { useState, useEffect } from "react";
import { Form, Table } from "react-bootstrap";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../reusableComponents/selectFilter";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import isEmpty from "../../../../store/validation/is-Empty";
import moment from "moment";
import {
  NEW_PAYMENT_TYPE,
  ORDER_STATUS,
  ORDER_TYPE,
  PAYMENT_TYPE,
} from "../../../../enums/OrderEnums";

const SuperAdminDeliveryOrderReport = ({ ...props }) => {
  const history = useHistory();
  const id =
    history.location.pathname.split("/")[
    history.location.pathname.split("/").length - 1
    ];
  const [orderData, setOrderData] = useState([]);
  const [orderStat, setOrderStat] = useState({});
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getReportData("ALL", dateQuery);
    }
  }, [auth]);

  const getReportData = async (type, dateQuery) => {
    let data = await axios.get(`${serverApi}/admin/dunzoOrders`, {
      params: { type: type, ...dateQuery },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setOrderData(data.data.orders);
      setOrderStat(data.data.stats);
    }
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    getReportData("ALL", data);
  };

  const renderData = orderData.filter((item) => {
    return (
      item?.order_id.toLowerCase().includes(search.toLowerCase()) ||
      item?.user_details?.last_name
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      item?.user_details?.first_name
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  });

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation

            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Delivery Report
                </div>
                <div>
                  <div
                    className="f14-700 mb-2"
                    align="right"
                    style={{ color: "#EE3A23" }}
                  >
                    {moment().format("[Today,] Do MMM YYYY")}
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Delivery Charges",
                        value: `₹ ${orderStat?.deliveryCharges
                          ? (orderStat?.deliveryCharges)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                          : 0
                          }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Order Total",
                        value: `₹ ${orderStat?.orderTotal
                          ? (orderStat?.orderTotal)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                          : 0
                          }`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      }
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "12%" }} className="f12-700">
                          User
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Order Type/ <br />
                          Order ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment Method
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Delivery <br />
                          Distance
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          User <br />Delivery Charges
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Merchant <br />Delivery Charges
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Amealio <br />Delivery Charges
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Estimated Delivery <br />
                          Charges
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Actual Delivery <br />
                          Charges
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Net Order <br />
                          Amount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Order Date
                          <br /> & Time
                        </th>
                      </tr>
                    </thead>
                    {renderData &&
                      renderData.map((data) => (
                        <tbody>
                          <tr className="super_admin_all_users_table_body">
                            <td style={{ width: "12%" }} className="f12-500">
                              <div class="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                                <div class="super-admin-suggestion-imageBoxTwo ml-2">
                                  <div class="f12-400">
                                    {`${data?.user_details?.first_name} ${data?.user_details?.last_name}`}{" "}
                                    <br />
                                    {`${data?.user_details?.country_code} ${data?.user_details?.mobile_number}`}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-400">
                              <div className="f12-400">{ORDER_TYPE[data?.order_type]}
                                <br />
                                {data?.order_id || ""}</div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-400">
                              <div className="f12-400">{NEW_PAYMENT_TYPE[data?.payment_method]}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {data?.delivery_quote?.distance}kms</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.deliveryCharges?.user || 0}`}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.deliveryCharges?.merchant || 0}`}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.deliveryCharges?.amealio || 0}`}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.delivery_quote?.estimated_price || 0}`}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.delivery_task?.price || 0}`}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.base_amount || 0}`}</div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-400">
                              <div className="f12-400"> {moment(data?.createdAt).format("ll")}</div>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminDeliveryOrderReport;
